var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.25,
    height: 70,
    viewBox: "0 0 299.25 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ment.svg",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_91",
    "data-name": "\\uC0AC\\uAC01\\uD615 91",
    width: 299.249,
    height: 70,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_276",
    "data-name": "\\uD328\\uC2A4 276",
    d: "M108.967,19.16V1.312h-57V66.419h57V48.571H73.546V41.7h31.886V26.035H73.546V19.16Z",
    transform: "translate(44.922 1.134)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_277",
    "data-name": "\\uD328\\uC2A4 277",
    d: "M60.92,1.312,45.167,43.928,29.414,1.312H0V66.421H21.035V31.967L35.24,66.421H54.819l14.386-34.94v34.94H90.151V1.312Z",
    transform: "translate(0 1.134)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_278",
    "data-name": "\\uD328\\uC2A4 278",
    d: "M85.859,1.312h25.862l22.4,36.424h.183V1.312h20.942V66.419H130.935L106.986,27.537h-.093V66.419H85.859Z",
    transform: "translate(74.224 1.134)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_279",
    "data-name": "\\uD328\\uC2A4 279",
    d: "M125.516,1.312V21.256H147.28V66.421h21.583V21.256h21.669V1.312Z",
    transform: "translate(108.506 1.134)",
    fill: "#1a1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMent);
export default __webpack_public_path__ + "static/media/ment.c2f7a34e9785f7db13da4fe6b8f358d3.svg";
export { ForwardRef as ReactComponent };